export default __webpack_public_path__ + "src/assests/longJump.mp3";